export default "__VITE_ASSET__DyE16djQ__"